import BusinessIcon from '@mui/icons-material/Business'
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { Link } from '../../router/components/Link'

interface Props {
  onItemClick: () => void
}

export const KetensamenwerkingMenu = ({ onItemClick }: Props) => {
  const { canViewProjectdossiers, canViewProjectmeldingen } =
    useAuthenticatedUser()

  const shouldRender = canViewProjectdossiers || canViewProjectmeldingen

  return shouldRender ? (
    <>
      <List subheader={<ListSubheader>Ketensamenwerking</ListSubheader>}>
        {canViewProjectmeldingen && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/vooraanmeldingen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <SwapHorizontalCircleIcon />
            </ListItemIcon>
            <ListItemText primary="Vooraanmeldingen" />
          </ListItemButton>
        )}

        {canViewProjectdossiers && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/projectdossiers"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText primary="Projectdossiers" />
          </ListItemButton>
        )}
      </List>

      <Divider />
    </>
  ) : null
}
